import CheckInInfo from './CheckInInfo';

export default CheckInInfo;
